import React from "react"

class Popup extends React.Component {

	render() {
		return (
			<div className={"modal is-active " + (this.props.className ? this.props.className : "")} style={{ zIndex: 99999 }}>
				<div className="modal-background" onClick={this.props.onHide} />
				<div className="modal-card">
					<header className="modal-card-head">
						<p className="modal-card-title">{this.props.title}</p>
						<button className="delete" aria-label="close" onClick={this.props.onHide}></button>
					</header>
					<section className="modal-card-body">
						{this.props.children}
					</section>
				</div>
			</div>
		)
	}

}

export default Popup



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/utils/popup.js